import { Image } from '@petsmart-ui/sparky';

import type { LegacyStarsProps } from './types';

export function LegacyStars({ href, rating, totalReviews, size, starsLength }: Readonly<LegacyStarsProps>) {
    const fillArray = Array.from({ length: starsLength }, (_, i) => i + 1);
    const { width, height } = size;
    const getImage = (src: string, index: number) => (
        <Image
            key={`us-${index}`}
            src={src}
            alt="ratings star"
            className="star-svg"
            loading="lazy"
            width={width}
            height={height}
        />
    );
    return (
        <a href={href} className="ratings-reviews-modal-link">
            <div className="stars-rating">{rating}</div>
            <div className="stars-container">
                <div className="unrated-stars-container">
                    {fillArray.map(i =>
                        getImage('https://images.petsmartassets.com/is/content/PetSmart/unrated-star-blue', i)
                    )}
                    <div className="total-review-count">{`${totalReviews} store reviews`}</div>
                </div>
                <div className="rated-stars-container">
                    {fillArray.map(i =>
                        getImage('https://images.petsmartassets.com/is/content/PetSmart/full-star-blue', i)
                    )}
                </div>
            </div>
        </a>
    );
}
